import { render } from "./okouinonmajeclatementoperation.vue?vue&type=template&id=71fdac7c&scoped=true"
import script from "./okouinonmajeclatementoperation.vue?vue&type=script&lang=js"
export * from "./okouinonmajeclatementoperation.vue?vue&type=script&lang=js"

import "./okouinonmajeclatementoperation.vue?vue&type=style&index=0&id=71fdac7c&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71fdac7c"]])

export default __exports__